import { api } from '../api';
import {
  WALLET_LIST_STATUS,
  USER_ASSETS,
  GET_PRICES
} from '../../constants/wallet';
import {
  MarketInfo,
  MarketInfos,
  UserTotalBalance,
  WalletAssetList
} from './types';

export const walletSlice = api.injectEndpoints({
  endpoints: (build) => ({
    assetList: build.query<WalletAssetList, void>({
      query: () => `${WALLET_LIST_STATUS}`
    }),
    getUserAssets: build.query<UserTotalBalance, void>({
      query: () => `${USER_ASSETS}`,
      // Refetched when an order or a transfer changes the balances
      providesTags: ['UserAssets']
    }),
    getAssetPrices: build.query<MarketInfos, { market: MarketInfos | [] }>({
      query: (data) => ({
        url: `${GET_PRICES}`,
        method: 'POST',
        body: data
      })
    })
  }),
  overrideExisting: false
});

export const {
  useAssetListQuery,
  useLazyAssetListQuery,
  useGetUserAssetsQuery,
  useGetAssetPricesQuery
} = walletSlice;
